module.exports = __webpack_public_path__ + "static/story4-cta-1920x515-ad7987cfc03c1c89fbd618136c2c4540.jpg";